/* Compose ta box : les couleurs choisies (et le mot pour Ivanedge) sont accrochées à la ligne de la box dans le panier.
   Le choix des pépites lui-même est géré par l'app Moon Bundles, affichée au-dessus du bouton d'achat. */
(function () {
  var body = document.body, handle = body.dataset.ivgHandle || '', kind = body.dataset.ivgKind || '';
  /* Page d'une pépite : « Composer ma box » emporte la variante affichée (celle de l'adresse si la cliente en a changé) */
  if (kind === 'bijou' || kind === 'beaute') {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.ivg-boxonly__btn[data-ivg-pick]');
      if (!a) return;
      var v = ''; try { v = new URL(location.href).searchParams.get('variant') || ''; } catch (err) {}
      var vid = v || a.getAttribute('data-ivg-pick'); if (!vid) return;
      try { var u = new URL(a.getAttribute('href'), location.origin); u.searchParams.set('ivg_pick', vid); a.setAttribute('href', u.pathname + u.search); } catch (err) {}
    }, true);
    return;
  }
  if (kind.indexOf('compose') !== 0) return;
  function init() {
    var w = document.querySelector('[data-ivg-compose]');
    if (!w) return;
    var f = document.getElementById(w.dataset.form), hint = w.querySelector('[data-ivg-hint]'), hidden = w.querySelector('[data-ivg-colors]');
    /* Pépite pré-remplie : « Composer ma box » depuis la page d'un bijou arrive ici avec ?ivg_pick=<variante>.
       On écrit la pépite dans la mémoire de l'app (localStorage) avant que son script ne démarre — ce fichier est chargé
       avant ceux de l'app — et elle l'affiche directement dans le premier emplacement libre de la box en cours.
       Si les identifiants du bundle ont changé (bundle recréé dans l'app), on les apprend à l'affichage et on recharge une fois. */
    var BUNDLES = {
      'compose-bijoux': { bundle: '37c378b6-e7f7-47ac-a877-9146914a575d', offer: '3b1e6c2a-5f4d-4e8b-9a1c-7d2f8e4b6a10', slot: 'a1d2c3b4-' },
      'compose-beaute': { bundle: '23f0549a-5366-43d4-95b3-a7d1cb1067e8', offer: '4c2f7d3b-6a5e-4f9c-8b2d-8e3a9f5c7b21', slot: 'b2e3d4c5-' }
    };
    function moonKeyFor(bundle) { return 'moonbundle_bm_v1_' + ((window.Shopify && Shopify.shop) || 'di027h-7m.myshopify.com') + '_' + bundle + '_session'; }
    function defaultSlots(prefix) { var out = []; for (var i = 1; i <= 12; i++) { var n = String(i); while (n.length < 4) n = '0' + n; out.push(prefix + n + '-4a1b-8c2d-' + ('000000000000' + i).slice(-12)); } return out; }
    function writePick(vid, ids) {
      var key = moonKeyFor(ids.bundle), s = null, gid = 'gid://shopify/ProductVariant/' + vid;
      try { s = JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) {}
      if (!s || typeof s !== 'object') { s = { v: 1, offerId: ids.offer, slotVariantSelections: {}, mpSlotLineCountByOffer: {} }; }
      var off = s.offerId || ids.offer, counts = s.mpSlotLineCountByOffer = s.mpSlotLineCountByOffer || {};
      if (!counts[off]) { counts[off] = {}; (ids.slots || defaultSlots(ids.slot)).forEach(function (sl) { counts[off][sl] = 1; }); }
      var slots = Object.keys(counts[off]), sels = s.slotVariantSelections = s.slotVariantSelections || {}, sel = sels[off] = sels[off] || {};
      var already = slots.some(function (sl) { return (sel[sl] || []).some(function (x) { return x && x.id === gid; }); });
      if (!already) {
        var free = slots.filter(function (sl) { return !(sel[sl] || []).length; })[0];
        if (!free) return 'full';
        sel[free] = [{ id: gid, available: true }];
      }
      s.ts = Date.now();
      try { localStorage.setItem(key, JSON.stringify(s)); } catch (e) { return 'error'; }
      return 'ok';
    }
    var pick = ''; try { pick = new URL(location.href).searchParams.get('ivg_pick') || ''; } catch (e) {}
    if (pick) {
      var ids = BUNDLES[kind] || null, learned = null;
      try { learned = JSON.parse(sessionStorage.getItem('ivgPickIds') || 'null'); } catch (e) {}
      if (learned && learned.pick === pick) ids = learned;
      var wrote = ids ? writePick(pick, ids) : 'noids';
      try { var cu = new URL(location.href); cu.searchParams.delete('ivg_pick'); history.replaceState(history.state, '', cu.pathname + cu.search + cu.hash); } catch (e) {}
      var t1 = Date.now();
      (function check() {
        var box = document.querySelector('.moonbundle-box[data-bundle-id]');
        if (!box) { if (Date.now() - t1 < 15000) setTimeout(check, 300); return; }
        var bid = box.getAttribute('data-bundle-id'), key = moonKeyFor(bid), s = null, ok = false;
        try { s = JSON.parse(localStorage.getItem(key) || 'null'); var sel = ((s || {}).slotVariantSelections || {})[(s || {}).offerId] || {};
          ok = Object.keys(sel).some(function (sl) { return (sel[sl] || []).some(function (x) { return x && x.id === 'gid://shopify/ProductVariant/' + pick; }); }); } catch (e) {}
        if (ok || wrote === 'full') { try { sessionStorage.removeItem('ivgPickIds'); } catch (e) {} setTimeout(function () { w.scrollIntoView({ block: 'center', behavior: 'smooth' }); }, 300); return; }
        if (learned || !s) return; /* déjà rechargé une fois, ou mémoire de l'app absente : on n'insiste pas */
        try { sessionStorage.setItem('ivgPickIds', JSON.stringify({ pick: pick, bundle: bid, offer: s.offerId, slots: Object.keys((s.mpSlotLineCountByOffer || {})[s.offerId] || {}) })); } catch (e) { return; }
        try { var ru = new URL(location.href); ru.searchParams.set('ivg_pick', pick); location.replace(ru.toString()); } catch (e) {}
      })();
    }
    function colors() { return [].slice.call(w.querySelectorAll('input[type=checkbox]:checked')).map(function (i) { return i.value; }); }
    function note() { return ((w.querySelector('textarea') || {}).value || '').trim(); }
    /* Prêt dès qu'une couleur est cochée ou qu'un mot est laissé à Ivanedge */
    function ready() { return !!(colors().length || note()); }
    /* Seuls les vrais boutons d'achat sont concernés : jamais ceux du tiroir panier de l'app (croix « Fermer le panier », quantités…) */
    function inCartDrawer(b) { return !!(b.closest && b.closest('.moonbundle-cart-drawer, moonbundle-cart-drawer-block, cart-drawer-component, .cart-drawer')); }
    function isAtc(b) { return !inCartDrawer(b) && (b.type === 'submit' || /panier|cart/i.test(b.textContent)); }
    function atcButtons() {
      var out = [];
      document.querySelectorAll('form[data-type="add-to-cart-form"] button, [class*="moonbundle"] button').forEach(function (b) { if (isAtc(b) && out.indexOf(b) < 0) out.push(b); });
      return out;
    }
    function lock() { var locked = !ready(); atcButtons().forEach(function (b) { b.classList.toggle('is-ivg-locked', locked); }); }
    function sync() {
      var c = colors();
      if (hidden) hidden.value = c.join(', ');
      if (ready()) { hint.hidden = true; w.classList.remove('is-ivg-attention'); }
      lock();
    }
    /* Chaque box ajoutée au panier reçoit son propre numéro et ses propres couleurs.
       Au clic « Ajouter au panier », on photographie le panier ; quand l'app a ajouté les pépites, on retrouve
       les seules lignes nouvelles et on leur accroche « Box N · couleurs » (visible dans le panier, au paiement,
       dans l'e-mail de confirmation et dans la commande) plus un identifiant interne qui empêche Shopify de fusionner
       deux box identiques. Les box précédentes ne sont jamais réécrites. */
    var HDR = { 'Content-Type': 'application/json', Accept: 'application/json' };
    function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
    function change(body) { return fetch('/cart/change.js', { method: 'POST', headers: HDR, body: JSON.stringify(body) }).then(function (r) { return r.json(); }); }
    function add(body) { return fetch('/cart/add.js', { method: 'POST', headers: HDR, body: JSON.stringify(body) }).then(function (r) { return r.json(); }); }
    function refreshCart() {
      /* même événement que celui d'une app externe : le thème re-dessine le tiroir, la page panier et le compteur du header */
      var p = getCart().then(function (cart) { return { detail: { itemCount: cart.item_count, items: cart.items } }; });
      try { var ev = new Event('shopify:cart:lines-update', { bubbles: true }); ev.promise = p; document.dispatchEvent(ev); } catch (e) {}
    }
    function isBundleLine(it) { var p = it.properties || {}; return !!p.__moonbundle && String(p.__moonbundle).indexOf(pid()) >= 0; }
    function pid() { return String((f.querySelector('input[name="product-id"]') || {}).value || ''); }
    var busy = false;
    function tagNewLines(snap) {
      var c = colors().join(', '), n = note(), t0 = Date.now();
      function diff(cart) {
        var news = [], merged = [], boxes = {};
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (p._ivg_box) boxes[p._ivg_box] = true;
          if (!isBundleLine(it)) return;
          var before = snap[it.key];
          /* une pépite de box sans numéro de box : elle vient d'être ajoutée par l'app */
          if (!p._ivg_box) { news.push(it); return; }
          /* une pépite déjà dans une box précédente dont la quantité a augmenté : Shopify a fusionné les deux box */
          if (before !== undefined && it.quantity > before) merged.push({ it: it, extra: it.quantity - before, before: before });
        });
        return { news: news, merged: merged, nb: Object.keys(boxes).length };
      }
      var lastSig = null;
      function poll() {
        getCart().then(function (cart) {
          var d = diff(cart);
          if (!d.news.length && !d.merged.length) {
            if (Date.now() - t0 < 15000) { setTimeout(poll, 600); } else { busy = false; }
            return;
          }
          /* l'app ajoute parfois les pépites en plusieurs fois : on attend que le panier ne bouge plus */
          var sig = cart.items.map(function (it) { return it.key + ':' + it.quantity; }).join('|');
          if (sig !== lastSig) { lastSig = sig; setTimeout(poll, 700); return; }
          var num = d.nb + 1, boxId = num + '-' + Date.now(), label = num + (c ? ' · ' + c : ''); /* propriété « Box » = « 1 · Doré » : lisible partout (panier, app Moon, paiement, commande) */
          var jobs = [];
          d.news.forEach(function (it) {
            var np = {}; Object.keys(it.properties || {}).forEach(function (k) { np[k] = it.properties[k]; });
            np['Box'] = label; np['_ivg_box'] = boxId; delete np['Couleurs de la box'];
            if (n) np['Précisions'] = n; else delete np['Précisions'];
            jobs.push(function () { return change({ id: it.key, quantity: it.quantity, properties: np }); });
          });
          /* une pépite déjà présente dans une box précédente, fusionnée par Shopify : on la re-sépare */
          d.merged.forEach(function (m) {
            var np = {}; Object.keys(m.it.properties || {}).forEach(function (k) { np[k] = m.it.properties[k]; });
            np['Box'] = label; np['_ivg_box'] = boxId; if (n) np['Précisions'] = n; else delete np['Précisions'];
            jobs.push(function () { return change({ id: m.it.key, quantity: m.before }); });
            jobs.push(function () { return add({ id: m.it.variant_id, quantity: m.extra, properties: np }); });
          });
          (function next() {
            var job = jobs.shift();
            if (!job) {
              busy = false;
              /* la box suivante repart de zéro côté couleurs */
              w.querySelectorAll('input[type=checkbox]:checked').forEach(function (i) { i.checked = false; });
              var ta = w.querySelector('textarea'); if (ta) ta.value = '';
              sync(); hint.hidden = true;
              refreshCart(); setTimeout(refreshCart, 1200);
              hasBox = true; showNewBox();
              return;
            }
            job().then(next, next);
          })();
        }, function () { busy = false; });
      }
      setTimeout(poll, 500);
    }
    function attach() {
      if (busy) return;
      busy = true;
      getCart().then(function (cart) {
        var snap = {}; cart.items.forEach(function (it) { snap[it.key] = it.quantity; });
        tagNewLines(snap);
      }, function () { busy = false; });
    }
    /* Bouton « Créer une nouvelle box », placé juste au-dessus des pépites de l'app : il vide les emplacements avec les
       croix de l'app elle-même (le panier n'est pas touché) et remet les couleurs à zéro. Il n'apparaît que lorsqu'une box
       est déjà dans le panier et que les emplacements sont encore remplis. */
    var nb = document.querySelector('[data-ivg-newbox]'), hasBox = false;
    function moonFilled() { return !!document.querySelector('.moonbundle-mp-slot-line-clear'); }
    function placeNewBox() {
      var mc = document.querySelector('moonbundle-component');
      if (mc && nb.nextElementSibling !== mc) mc.parentNode.insertBefore(nb, mc);
    }
    function showNewBox() { if (!nb) return; placeNewBox(); nb.hidden = !(hasBox && moonFilled()); }
    function clearSlots(done) {
      var tries = 0;
      (function step() {
        var x = document.querySelector('.moonbundle-mp-slot-line-clear');
        if (!x || tries++ > 40) { done(!x); return; }
        x.click(); setTimeout(step, 250);
      })();
    }
    if (nb) {
      nb.addEventListener('click', function () {
        nb.disabled = true;
        clearSlots(function (ok) {
          w.querySelectorAll('input[type=checkbox]:checked').forEach(function (i) { i.checked = false; });
          var ta = w.querySelector('textarea'); if (ta) ta.value = '';
          sync(); nb.disabled = false; showNewBox();
          w.scrollIntoView({ block: 'center', behavior: 'smooth' });
          if (!ok) {
            /* secours si l'app ne répond pas : on efface sa mémoire et on recharge la page (le panier est conservé) */
            try { Object.keys(localStorage).forEach(function (k) { if (/^moonbundle_bm_v1_.*_session$/.test(k)) localStorage.removeItem(k); }); } catch (e) {}
            location.reload();
          }
        });
      });
      getCart().then(function (cart) { hasBox = cart.items.some(isBundleLine); showNewBox(); }, function () {});
    }
    /* Ni couleur ni mot : on bloque l'ajout au panier, on remonte au bloc couleurs et on montre le rappel.
       Écouteur sur window en phase de capture : il passe avant celui du thème (document), donc avant l'animation « vol vers le panier ». */
    window.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button');
      if (!b || !b.closest('form[data-type="add-to-cart-form"], [class*="moonbundle"]')) return;
      if (inCartDrawer(b) || !isAtc(b)) return;
      if (!ready()) {
        e.preventDefault(); e.stopImmediatePropagation();
        hint.hidden = false;
        w.classList.remove('is-ivg-attention'); void w.offsetWidth; w.classList.add('is-ivg-attention');
        w.scrollIntoView({ block: 'center', behavior: 'smooth' });
        var first = w.querySelector('input[type=checkbox]'); if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 500);
        return;
      }
      attach();
    }, true);
    w.addEventListener('change', sync); w.addEventListener('input', sync); sync();
    new MutationObserver(function () { lock(); showNewBox(); }).observe(document.body, { childList: true, subtree: true });
  }
  /* Boutons de type (colliers, bracelets…) au-dessus de la recherche de la fenêtre de choix de l'app */
  var CHIPS = kind === 'compose-beaute'
    ? [['Tous', ''], ['Parfums', 'parfum'], ['Brumes', 'brume'], ['Soins', 'soin'], ['Maquillage', 'maquillage']]
    : [['Tous', ''], ['Colliers', 'collier'], ['Bracelets', 'bracelet'], ['Charms', 'charm'], ['Bagues', 'bague'], ["Boucles d'oreilles", 'boucles']];
  function addChips(search) {
    if (search.querySelector('.ivg-chips-popup')) return;
    var input = search.querySelector('input');
    if (!input) return;
    var row = document.createElement('div'); row.className = 'ivg-chips-popup';
    CHIPS.forEach(function (c, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'ivg-chip' + (i === 0 ? ' is-active' : ''); b.textContent = c[0];
      b.addEventListener('click', function () {
        row.querySelectorAll('.ivg-chip').forEach(function (x) { x.classList.remove('is-active'); }); b.classList.add('is-active');
        var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
        setter.call(input, c[1]); input.dispatchEvent(new Event('input', { bubbles: true }));
      });
      row.appendChild(b);
    });
    search.insertBefore(row, input);
  }
  /* Étape « finition » de l'app : pastilles de couleur au lieu des cartes photo */
  var COLORS = { 'dore': '#dcb977', 'or': '#dcb977', 'argente': '#cfd2d6', 'argent': '#cfd2d6', 'mixte': 'linear-gradient(90deg,#dcb977 50%,#cfd2d6 50%)',
    'rose': '#f2a3b7', 'rouge': '#c8322f', 'bleu': '#3b74d1', 'vert': '#3f9b5b', 'noir': '#1d1a1b', 'blanc': '#ffffff', 'beige': '#e3d1b2', 'jaune': '#f3d04a',
    'violet': '#7c4ab3', 'orange': '#f08a2c', 'marron': '#6f4a2f', 'gris': '#9a9a9e', 'lilas': '#c9b1e6', 'corail': '#f47a63', 'ambre': '#f2b24a', 'bronze': '#b07a46',
    'champagne': '#f1dcb0', 'multicolore': 'conic-gradient(#e94f6a,#f2cf3a,#4fb36c,#3b82d6,#8a55c8,#e94f6a)', 'leopard': 'radial-gradient(circle,#3b2a1a 22%,transparent 24%) 0 0/8px 8px,#d9a066',
    'turquoise': '#35c0c5', 'fuschia': '#d81b72', 'fuchsia': '#d81b72', 'marine': '#1b2a52', 'ciel': '#a9d2f3', 'transparent': '#eef3f8',
    'bordeaux': '#7a1f2b', 'framboise': '#b8315a', 'eau': '#9fd8cf', 'holographique': 'conic-gradient(#f9c6d8,#c6e2f9,#d9f9c6,#f9f0c6,#f9c6d8)', 'pois': null };
  function colorFor(label) {
    var t = label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    var words = t.split(/[^a-z]+/).filter(Boolean), found = [];
    words.forEach(function (w) { if (COLORS[w] && found.indexOf(COLORS[w]) < 0) found.push(COLORS[w]); });
    if (!found.length) return null;
    if (found.length === 1) return found[0];
    return 'linear-gradient(135deg,' + found[0] + ' 50%,' + found[1] + ' 50%)';
  }
  function dotVariants(card) {
    if (card.querySelector('.ivg-vdot')) return;
    var label = card.querySelector('.moonbundle-dynamic-popup-variant-card-label');
    if (!label) return;
    var c = colorFor(label.textContent);
    var dot = document.createElement('span'); dot.className = 'ivg-vdot' + (c ? '' : ' ivg-vdot--none');
    if (c) dot.style.background = c;
    label.insertBefore(dot, label.firstChild);
    card.classList.add('ivg-vcard');
  }
  /* Emplacements affichés au fur et à mesure : les pépites choisies + un seul emplacement vide (effet « à l'infini ») */
  function tidySlots(layout) {
    var kids = [].slice.call(layout.children), emptySeen = false, show = [];
    kids.forEach(function (k, i) {
      if (k.classList.contains('moonbundle-horizontal-separator')) { show[i] = null; return; }
      var empty = !!k.querySelector('.moonbundle-ai-slot-picker-cta');
      if (!empty) { show[i] = true; return; }
      show[i] = !emptySeen; emptySeen = true;
    });
    kids.forEach(function (k, i) {
      if (show[i] === null) { var nxt = show[i + 1]; k.style.display = nxt === false ? 'none' : ''; return; }
      k.style.display = show[i] ? '' : 'none';
    });
  }
  /* La fenêtre de l'app ne charge la collection que par lots au défilement, et sa recherche ne filtre que ce qui est chargé.
     Rien ne bouge à l'ouverture. À la première recherche (texte ou onglet), on charge toute la liste, masquée, puis on
     applique la recherche. L'app ignore les défilements trop rapprochés : on ne défile qu'après chaque lot reçu. */
  var valueSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  function fireInput(input) { var ev = new Event('input', { bubbles: true }); ev.ivgSilent = true; input.dispatchEvent(ev); }
  function loadAll(list, done) {
    var lastCount = -1, lastScrollAt = 0, quietSince, t0;
    /* Défilement vers le bas qui change toujours de position : si la liste est déjà en bas,
       redonner la même valeur ne déclenche aucun événement et l'app ne charge rien. */
    function nudge() {
      var bottom = list.scrollHeight - list.clientHeight;
      list.scrollTop = Math.max(0, bottom - 40);
      setTimeout(function () { list.scrollTop = list.scrollHeight; }, 60);
    }
    function step() {
      var count = list.querySelectorAll('.moonbundle-dynamic-popup-product-card').length, now = Date.now();
      var sentinel = list.querySelector('.moonbundle-dynamic-popup-load-sentinel');
      if (count !== lastCount) quietSince = now;
      /* la sentinelle disparaît aussi pendant chaque lot : on attend 2,5 s sans nouveau produit avant de conclure */
      if (now - quietSince > 2500 || now - t0 > 25000) { list.scrollTop = 0; done(); return; }
      if (count !== lastCount || now - lastScrollAt > 700) { nudge(); lastScrollAt = now; }
      lastCount = count;
      setTimeout(step, 100);
    }
    /* on laisse l'app réafficher la liste complète avant de commencer */
    setTimeout(function () { quietSince = t0 = Date.now(); list.scrollTop = 0; step(); }, 600);
  }
  function wireSearch(overlay) {
    var input = overlay.querySelector('.moonbundle-dynamic-popup-search input'), list = overlay.querySelector('.moonbundle-dynamic-popup-product-list');
    if (!input || !list || input.dataset.ivgWired) return;
    input.dataset.ivgWired = '1';
    var pending = '';
    input.addEventListener('input', function (e) {
      if (e.ivgSilent || list.dataset.ivgLoaded === 'done') return;
      if (list.dataset.ivgLoaded === 'busy') { pending = input.value; e.stopImmediatePropagation(); return; } /* l'app ne voit pas les frappes pendant le chargement */
      if (!input.value.trim()) return;
      /* Les charms sont chargés en premier par l'app (collection Charms placée avant Bijoux dans le bundle) : filtre immédiat */
      if (/^charm/i.test(input.value.trim())) return;
      e.stopImmediatePropagation();
      var wanted = input.value; pending = wanted;
      list.dataset.ivgLoaded = 'busy'; overlay.classList.add('ivg-loading');
      valueSetter.call(input, ''); fireInput(input); valueSetter.call(input, wanted); /* liste complète côté app, texte conservé à l'écran */
      loadAll(list, function () {
        list.dataset.ivgLoaded = 'done'; overlay.classList.remove('ivg-loading');
        /* l'app peut avoir vidé le champ en se réaffichant : on remet la dernière recherche demandée, puis on l'applique */
        valueSetter.call(input, pending); fireInput(input);
      });
    }, true);
  }
  new MutationObserver(function () {
    document.querySelectorAll('.moonbundle-dynamic-popup-overlay').forEach(wireSearch);
    document.querySelectorAll('.moonbundle-dynamic-popup-search').forEach(addChips);
    document.querySelectorAll('.moonbundle-dynamic-popup-variant-card').forEach(dotVariants);
    document.querySelectorAll('.moonbundle-multi-product-horizontal-layout').forEach(tidySlots);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
